module.exports = __webpack_public_path__ + "media/theme/icon__response--retina-ea2554fd.png";